'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var loadDynamicScript = exports.loadDynamicScript = function loadDynamicScript(src, id) {
  return function (callback, setStateCallback) {
    var existingScript = document.getElementById(id);

    if (!existingScript) {
      var script = document.createElement('script');
      script.src = src; // URL for the third-party library being loaded.
      script.id = id; // e.g., googleMaps or stripe
      if (document.body) document.body.appendChild(script);

      script.onload = function () {
        if (callback) callback();
      };
    }
    if (setStateCallback) {
      callback();
    }
  };
};